export const formatBlogPostTimestamp = timestamp => {
    const d = new Date(timestamp);
    const date = d.getDate();
    const month = d.toLocaleString('en-us', { month: 'long' });
    const year = d.getUTCFullYear();
    const formattedDate = `${month} ${date}, ${year}`;

    return formattedDate;
};